import { userSignedInReaction } from 'src/features/cart/epics/userSignedInReaction.epic';
import { cartFetch2 } from 'src/features/cart/epics/cartFetch2.epic';
import { cartRegister as baseCartRegister } from 'src/core/state/cart';

export function cartRegister() {
    return baseCartRegister({
        userSignedInReaction,
        cartFetch: cartFetch2,
    } as any);
}
